import Providers from './_providers'
import Auth from './pages/auth'
import Routes from 'routes'
import Screens from '_screens'
import {useEffect, useRef} from 'react'
import OneSignal from 'react-onesignal'

function App() {
    const token = localStorage.getItem('@token')
    const isInitialized = useRef(false)
    const appId = process.env.REACT_APP_ONESIGNAL_APP_ID

    useEffect(() => {
        if (!isInitialized.current) {
            isInitialized.current = true;

            OneSignal.init({
                appId: appId,
                allowLocalhostAsSecureOrigin: true,
                notifyButton: {enabled: false},
                welcomeNotification: {disable: true}
            }).catch(err => {
                if (!err.message?.includes('already initialized')) {
                    console.error('OneSignal init error:', err);
                }
            });
        }
    }, [])

    return (
        <Providers>
            {!!token ? <Routes/> : <Auth/>}
            <Screens/>
        </Providers>
    );
}

export default App;